import { useGamificationDataStore } from './gamificationDataStore'

export const usePrizesStore = () => {
  const { prizes } = useGamificationDataStore(s => s.getActiveProductData())

  return { prizes }
}
